// extracted by mini-css-extract-plugin
export default {"settings":"oKyXBlXSki4jJgZFiYha","container":"cU99CNKyVM9c4VHbaIlh"};